module.exports = __webpack_public_path__ + "static/media/image8.68f555fb.png";